import React, { PureComponent } from 'react';
import withWidth, { LARGE, SMALL } from 'material-ui/utils/withWidth';
import './AuthedRouteWrapper.css';
import Header from '../../presenters/authed-route-wrapper/Header/Header';
import { bindActionCreators } from 'redux';
import actions from '../../../actions';
import { connect } from 'react-redux';
import { CURRENT_THEME_NAME } from '../../../config';
import { updateContentDimensions } from './authedUtils';
import LeftDrawer from './LeftDrawer/LeftDrawer';
import { SIGN_IN_URL } from '../../../route-names';
import { withRouter } from 'react-router-dom';
import { clearAllItems } from '../../../utils/session-util';

class AuthedRouteWrapper extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      navDrawerOpen: false,
      themeSelected: 'dark'
    };

    this.handleChangeRequestNavDrawer =
      this.handleChangeRequestNavDrawer.bind(this);
    this.signOut = this.signOut.bind(this);
    this.changeMode = this.changeMode.bind(this);
  }

  componentDidMount() {
    const { width } = this.props;
    this.setState({ navDrawerOpen: width === LARGE });
    window.addEventListener('resize', updateContentDimensions);
    updateContentDimensions();
  }

  componentDidUpdate() {
    updateContentDimensions();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', updateContentDimensions);
  }

  handleChangeRequestNavDrawer() {
    this.setState({
      navDrawerOpen: !this.state.navDrawerOpen
    });
  }

  signOut() {
    clearAllItems();
    this.props.actions.signOut();
    this.props.history.push(SIGN_IN_URL);
  }

  changeMode() {
    window.location.reload();
  }

  render() {
    const { width, navDrawerOpen } = this.state;
    return (
      <div className={`${CURRENT_THEME_NAME} layout-fluid`}>
        <Header
          navDrawerOpen={navDrawerOpen}
          handleChangeRequestNavDrawer={this.handleChangeRequestNavDrawer}
          signOut={this.signOut}
          changeMode={this.changeMode}
        />
        <LeftDrawer
          navDrawerOpen={navDrawerOpen}
          location={this.props.location}
          isMobileBrowser={this.props.appStore.isMobileBrowser}
          handleChangeRequestNavDrawer={this.handleChangeRequestNavDrawer}
        />
        <div
          className="main-container"
          style={{
            paddingLeft: this.state.navDrawerOpen && width !== SMALL ? 250 : 20
          }}
        >
          {this.props.children}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  appStore: state.get('app').toJS()
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(actions, dispatch)
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(withWidth()(AuthedRouteWrapper))
);
